import konaInput from '@/tag/konaInput';
import konaSelect from '@/tag/konaSelect';
import konaTable from '@/tag/konaTable';

export default {
    install(app) {
        app.component('kona-input', konaInput);
        app.component('kona-select', konaSelect);
        app.component('kona-table', konaTable);
    }
}